export const entranceBilling = {
	tabs: {
		boxOfficeBilling: {
			title: "Facturación de Taquilla",
			tabLabel: "Facturación",
		},
		entranceReport: {
			title: "Total de entradas vendidas",
			tabLabel: "Entradas vendidas",
			tabs: {
				total: "Total",
				clients: "Clientes por entrada",
			},
			columns: {
				name: "Nombre",
				count: "Cantidad",
				unitValue: "Valor unitario",
				subtotal: "Subtotal",
				discountValue: "Descuentos",
				totalValue: "Valor total",
			},
		},
	},
};
